var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcommerceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.427 26.978H20.76c-.657 0-1.191-.534-1.191-1.19V24.12h-7.14v1.666c0 .657-.535 1.191-1.192 1.191H9.574a.713.713 0 1 0 0 1.428h12.853a.714.714 0 1 0 0-1.428zM3.813 21.931c0 .394.32.714.714.714h22.946a.713.713 0 0 0 .715-.714V19.79H3.813v2.142zm10.4-8.57h4.176l.48-2.856h-5.19l.534 2.857z",
    fill: "#6238F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.473 4.031H4.527a.714.714 0 0 0-.715.714v13.616h24.375V4.745a.714.714 0 0 0-.714-.714zM14.334 16.933a.714.714 0 1 1 0-1.429.714.714 0 0 1 0 1.429zm4.284 0a.715.715 0 1 1 .001-1.43.715.715 0 0 1 0 1.43zm1.8-7.023-.721 4.284a.712.712 0 0 1-.704.597H13.62a.714.714 0 0 1-.702-.584l-1.089-5.843h-1.065a.715.715 0 0 1 0-1.429h1.658c.344 0 .639.246.703.584l.29 1.559h6.3c.44 0 .778.396.704.832z",
    fill: "#6238F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommerceIcon);
export default __webpack_public_path__ + "static/media/ecommerce-icon.4266c88d985d1d86bbe8b14f4a939038.svg";
export { ForwardRef as ReactComponent };